// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.right_side {
    margin-left: 1vw;
    padding-left: 1vw;
    /* border-radius: 14px; */
    padding-right: 1vw;
    padding-bottom: 2vh;
}
.bar_chart_main {
    display: flex;
    margin-top: 2.7vh;
}
.chart_dropdown{
    padding: 4px;
    background-color: #9BBF53;
    color: white;
    border: none;
    margin: 4px;
    border-radius: 2px;
}
/* .bar_chart,.bar_chart2 {
    margin-top: 4vh;
    width: 27vw;
    height: 29vh;
    background-color: white;
}
.bar_chart2 {
    margin-left: 1vw;
} */
.line_charts {
    display: flex;
}
/* .line2_chart {
    background-color: white ;
    width: 27vw;
    height: 29vh;
    margin-left: 1vw;
} */

.date_time_picker{
    border: 2px solid black;
    
}

.select_timeline_chart {
    margin-left: 1vw;
}

.graph_radio{
    border: 1px solid black;
    padding-right:8px;
    border-radius: 4px;
    margin-top: 2.5vh;
    margin-bottom: 2vh;
    background-color: white;
    width: 7vw;
}

.show_graph {
    background: #A9C86A;
    border-radius: 7px;
    /* position: absolute; */
    width: 78px;
    height: 34px;
    text-align: center;
    padding-top: 5px;
    padding-left: 15px;
    padding-right: 15px;
    margin-top: 90px;
    cursor: pointer;
    margin-left: 10px;
    transform: translateY(0px) translateX(6px);
    font-family: 'Poppins';
    
}

.chart_outing{
    border: 2px solid black;
}

.warning_box {
    position: absolute;
    left: 40vw;
    width: 30vw;
    top: 2vh;
}


.linec1,.linec2 {
    box-shadow: 20px 0px 24px rgba(0, 0, 0, 0.01);
    /* border-radius: 14px; */
    border: 0.5px solid #E8E8E8;
}

.linec2 {
    margin-left: 1vw;
}


.speed_legend {
    font-size: 1vmax;
    font-weight: 600;
    margin-left: .5vw;
}

.display_legend_icon {
    margin-top: .3vh;
    margin-bottom: .5vh;
    display: flex;
    justify-content: space-between;
}

.speed_legend_unit {
    font-size: .7vmax;
    color: rgba(0, 0, 0, 0.5);
    margin-left: .5vw;
    
}

.color_legend_container {
    display: flex;
    /* background-color: white;  */
    /* padding-left: 1.3vw;
    padding-right: .5vw;
    padding-top: 1vh;
    padding-bottom: 1vh; */
}

.color_legend {
    background-color: white; 
    width: -moz-fit-content; 
    width: fit-content;
    /* margin-left: .2vw;
    margin-bottom: 1.5vh; */
    border-radius: 4px;
    
}

.trend_condition_text1 {
    font-size: 0.6vmax;
    margin-right: 1vw;
    margin-top: .3vh;
}

.clb {
    box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/Components/ModelBoard/Analytics/index.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;;;;;;;;GAQG;AACH;IACI,aAAa;AACjB;AACA;;;;;GAKG;;AAEH;IACI,uBAAuB;;AAE3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0CAA0C;IAC1C,sBAAsB;;AAE1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,QAAQ;AACZ;;;AAGA;IACI,6CAA6C;IAC7C,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;;AAErB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B;;;0BAGsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,uBAAkB;IAAlB,kBAAkB;IAClB;2BACuB;IACvB,kBAAkB;;AAEtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".right_side {\r\n    margin-left: 1vw;\r\n    padding-left: 1vw;\r\n    /* border-radius: 14px; */\r\n    padding-right: 1vw;\r\n    padding-bottom: 2vh;\r\n}\r\n.bar_chart_main {\r\n    display: flex;\r\n    margin-top: 2.7vh;\r\n}\r\n.chart_dropdown{\r\n    padding: 4px;\r\n    background-color: #9BBF53;\r\n    color: white;\r\n    border: none;\r\n    margin: 4px;\r\n    border-radius: 2px;\r\n}\r\n/* .bar_chart,.bar_chart2 {\r\n    margin-top: 4vh;\r\n    width: 27vw;\r\n    height: 29vh;\r\n    background-color: white;\r\n}\r\n.bar_chart2 {\r\n    margin-left: 1vw;\r\n} */\r\n.line_charts {\r\n    display: flex;\r\n}\r\n/* .line2_chart {\r\n    background-color: white ;\r\n    width: 27vw;\r\n    height: 29vh;\r\n    margin-left: 1vw;\r\n} */\r\n\r\n.date_time_picker{\r\n    border: 2px solid black;\r\n    \r\n}\r\n\r\n.select_timeline_chart {\r\n    margin-left: 1vw;\r\n}\r\n\r\n.graph_radio{\r\n    border: 1px solid black;\r\n    padding-right:8px;\r\n    border-radius: 4px;\r\n    margin-top: 2.5vh;\r\n    margin-bottom: 2vh;\r\n    background-color: white;\r\n    width: 7vw;\r\n}\r\n\r\n.show_graph {\r\n    background: #A9C86A;\r\n    border-radius: 7px;\r\n    /* position: absolute; */\r\n    width: 78px;\r\n    height: 34px;\r\n    text-align: center;\r\n    padding-top: 5px;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    margin-top: 90px;\r\n    cursor: pointer;\r\n    margin-left: 10px;\r\n    transform: translateY(0px) translateX(6px);\r\n    font-family: 'Poppins';\r\n    \r\n}\r\n\r\n.chart_outing{\r\n    border: 2px solid black;\r\n}\r\n\r\n.warning_box {\r\n    position: absolute;\r\n    left: 40vw;\r\n    width: 30vw;\r\n    top: 2vh;\r\n}\r\n\r\n\r\n.linec1,.linec2 {\r\n    box-shadow: 20px 0px 24px rgba(0, 0, 0, 0.01);\r\n    /* border-radius: 14px; */\r\n    border: 0.5px solid #E8E8E8;\r\n}\r\n\r\n.linec2 {\r\n    margin-left: 1vw;\r\n}\r\n\r\n\r\n.speed_legend {\r\n    font-size: 1vmax;\r\n    font-weight: 600;\r\n    margin-left: .5vw;\r\n}\r\n\r\n.display_legend_icon {\r\n    margin-top: .3vh;\r\n    margin-bottom: .5vh;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.speed_legend_unit {\r\n    font-size: .7vmax;\r\n    color: rgba(0, 0, 0, 0.5);\r\n    margin-left: .5vw;\r\n    \r\n}\r\n\r\n.color_legend_container {\r\n    display: flex;\r\n    /* background-color: white;  */\r\n    /* padding-left: 1.3vw;\r\n    padding-right: .5vw;\r\n    padding-top: 1vh;\r\n    padding-bottom: 1vh; */\r\n}\r\n\r\n.color_legend {\r\n    background-color: white; \r\n    width: fit-content;\r\n    /* margin-left: .2vw;\r\n    margin-bottom: 1.5vh; */\r\n    border-radius: 4px;\r\n    \r\n}\r\n\r\n.trend_condition_text1 {\r\n    font-size: 0.6vmax;\r\n    margin-right: 1vw;\r\n    margin-top: .3vh;\r\n}\r\n\r\n.clb {\r\n    box-shadow: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
